import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import BottomNav from './BottomNav';
import Header from './Header';
import MobileDrawer from './MobileDrawer';
import NudgeBanner from '../common/NudgeBanner';

// Per shared-docs/frontend-architecture.md the canonical layout is:
//   - <header> sticky top-0 z-30 safe-area-top
//   - <main> max-w-2xl mx-auto (672px reading width)
//   - <nav> fixed bottom-0 z-30 md:hidden safe-area-bottom
//   - <aside> hidden md:flex fixed left-0 top-0 w-64
// The outer wrapper compensates for the bottom nav on mobile (`pb-20`) and the desktop
// sidebar (`md:pl-64`) so content never sits under the chrome.
export default function Layout() {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-night-bg pb-20 md:pb-0 md:pl-64">
      <Sidebar />
      <MobileDrawer />
      <Header />
      <main className="max-w-2xl mx-auto px-4 py-4">
        <NudgeBanner />
        <Outlet />
      </main>
      <BottomNav />
    </div>
  );
}
